



























































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch, Model } from "vue-property-decorator";
import { sendDeviceCommand, SendDeviceCommandReq } from "@/api/device";
import {
  SendDataReq,
  sendData,
  meters,
  GetPowerConditionerDataReq,
  getPowerConditionerData,
  PowerConditioner,
  ReCalculateUsageReq,
  reCalculateUsage,
} from "@/api/meter";
import { GetMeterReq, getMeterData, History } from "@/api/home";
import { FirewareCommonReq, geFirewares } from "@/api/fireware";
import {
  ElectricRecordDay,
  Fireware,
  Meter,
  ResCode,
  RsNetwork,
  SimplifyMeter,
} from "@/api/baseDefine";
import { GetRsNetworksReq, RsNetworkData, rsNetworks } from "@/api/rsNetwork";
import { Message } from "element-ui";
import { param } from "@/utils";
@Component({
  components: {},
})
export default class MeterDataSendDialog extends Vue {
  private selectMeters: Meter[] = [];
  private dialogSendData = false;
  private queryFirewares: Fireware[] = [];
  private selectElectricRecordDay: string = "";
  private electricRecordDays: string[] = [];
  private selectElectricRecordDays: ElectricRecordDay[] = [];
  private dialogClearKey = false;
  private param2s = ["ON", "OFF"];
  private dialogReCalculateUsage = false;
  private programCpc = ""
  private rs485SwitchControl = ""
  private clickShow(meters: Meter[]) {
    console.log("clickShow", meters);
    this.dialogSendData = true;
    this.selectMeters = meters;

    this.param1 = "";
    this.param2 = "";
    this.param3 = "";
    this.param4 = "";
    this.param5 = "";
    this.param6 = "";
    this.param7 = "";
    this.param8 = "";
    this.param9 = "";
    this.param10 = "";
    this.param11 = "";
    this.param12 = "";
    this.param13 = "";
    this.firewareID = "";

    this.apn = "";
    this.user = "";
    this.password = "";
    this.authenication = "";
    this.ipAddress = "";
    this.port = "";
  }

  private firewareID = "";
  private firewareMeterTypeID = 0;
  private param1 = "";
  private param2 = "";
  private param3 = "";
  private param4 = "";
  private param5 = "";
  private param6 = "";
  private param7 = "";
  private param8 = "";
  private param9 = "";
  private param10 = "";
  private param11 = "";
  private param12 = "";
  private param13 = "";

  private apn = "";
  private user = "";
  private password = "";
  private authenication = "";

  private ipAddress = "";
  private port = "";
  private isSending: boolean = false;

  private wifiSSID = "";
  private wifiPassword = "";
  private staSSID = "";
  private staPassword = "";
  private selectBaudRates: number[] = [
    2400, 4800, 9600, 19200, 38400, 115200, 153600,
  ];
  private param1s: {
    label: string;
    value: string;
  }[] = [];
  private recordDayMap: Map<string, ElectricRecordDay> = new Map();
  private parameter_tables = [
    {
      'code':'0x00',
      'des':'PCS and Solar Max power (W)',
      "parameter_default":'',
      'parameter_type':''
    },
    {
      'code':'0x01',
      'des':'IP addess and port buffer',
      "parameter_default":'',
      'parameter_type':''
    }
  ]

    private parameter_type_tables = [
    {
      'code':'0x00',
      'des':'PCS and Solar Max power (W)',
      "parameter_default":'',
      'parameter_type':''
    },
    {
      'code':'0x01',
      'des':'IP addess and port buffer',
      "parameter_default":'',
      'parameter_type':''
    }
  ]
  private parameter = ""
  private parameter_type = ""
  private parameter_code = ""
  private parameter_type_code = ""

 
  private sendProgramCpc(param:number){
    console.log(this.programCpc)
    let req: SendDataReq = this.generateSendDataReq(-2);
    req.dataType = 1
    if(param==8){
      req.params = param+","+this.programCpc;
    }else if(param==9){
      req.params = param+""
    }
    this.realSendData(req);
  }
  /**
   * 发送清除key的数据包
   */
  public async sendClearKeyCommand() {
    console.log("sendClearKeyCommand");
    let req: SendDataReq = this.generateSendDataReq(-2);
    req.params = "clear master key";
    this.realSendData(req);
  }

  public async sendReCalculateUsage() {
    let req: ReCalculateUsageReq = <ReCalculateUsageReq>{};
    req.meterID = this.selectMeters[0].meterID;
    let res = await reCalculateUsage(req);
    if (res.code == ResCode.SUCCESS) {
      this.dialogReCalculateUsage = false;
    }
  }



  // 发送sim card info to meter
  public async sendSIMCardInfo() {
    if (!this.apn || !this.authenication) {
      this.sendDataInputIllegal();
      return;
    }
    if (!this.user) {
      this.user = "";
    }
    if (!this.password) {
      this.password = "";
    }
    let req: SendDataReq = this.generateSendDataReq(6);
    req.params =
      "4," +
      this.apn +
      "," +
      this.user +
      "," +
      this.password +
      "," +
      this.authenication;
    this.realSendData(req);
  }

  // 发送 ip port
  public async sendIPAndPort() {
    if (!this.ipAddress || !this.port) {
      this.sendDataInputIllegal();
      return;
    }
    let req: SendDataReq = this.generateSendDataReq(6);
    req.params = "5," + this.ipAddress + "," + this.port;
    this.realSendData(req);
  }

  private async sendParameter(){
    if (!this.parameter_code || !this.parameter) {
      this.sendDataInputIllegal();
      return;
    }
    let req: SendDataReq = this.generateSendDataReq(6);
    req.params = "6," + this.parameter_code + "," + this.parameter;
    this.realSendData(req);
  }

  private async sendParameterType(){
    if (!this.parameter_type_code || !this.parameter_type) {
      this.sendDataInputIllegal();
      return;
    }
    let req: SendDataReq = this.generateSendDataReq(6);
    req.params = "6," + this.parameter_type_code + "," + this.parameter_type;
    this.realSendData(req);
  }
  public async sendWifi() {
    console.log(this.wifiSSID, this.wifiPassword);
    let json: any = {
      cmd: "Wifi",
      act: [{ SSID: this.wifiSSID }, { PWD: this.wifiPassword }],
    };
    let data: string = JSON.stringify(json);
    sendDeviceCommand(<SendDeviceCommandReq>{
      meterID: this.selectMeters[0].meterID,
      comandType: "pass",
      data: data,
    });
  }


  public async sendSta() {
    console.log(this.staSSID, this.staPassword);
    let json: any = {
      cmd: "STA",
      act: [{ SSID: this.staSSID }, { PWD: this.staPassword }],
    };
    let data: string = JSON.stringify(json);
    sendDeviceCommand(<SendDeviceCommandReq>{
      meterID: this.selectMeters[0].meterID,
      comandType: "pass",
      data: data,
    });
  }


  private sendRs485SwitchControl(){
    console.log(this.rs485SwitchControl)
    let req: SendDataReq = this.generateSendDataReq(8);
    req.dataType = 8
    req.bRs485 = true
    req.params = "10,0007,1,11,"+ this.rs485SwitchControl
    this.realSendData(req);
  }

  public async send(dataType: number) {
    let req: SendDataReq = this.generateSendDataReq(dataType);
    if (dataType == 1) {
      if (this.param1 == "-2") {
        this.sendElectricRecord();
        return;
      }else if (this.param1=="-1"){
          req.dataType = 8
          req.bRs485 = true
          req.params = "04,5000,40,10"
      }else if (this.param1 == "2" || this.param1 == "6") {
        if (
          !this.param2 ||
          !this.param3 ||
          new Date(this.param2).getTime() >= new Date(this.param3).getTime()
        ) {
          this.sendDataInputIllegal();
          return;
        }
        req.params =
          this.param1 +
          "," +
          Math.floor(new Date(this.param2).getTime() / 1000) +
          "," +
          Math.floor(new Date(this.param3).getTime() / 1000);
      } else {
        req.params = this.param1;
      }
    } else if (dataType == 2) {
      req.params = this.param4;
    } else if (dataType == 3) {
      if (!this.param5) {
        this.sendDataInputIllegal();
        return;
      }
      req.params = Math.floor(new Date(this.param5).getTime() / 1000) + "";
    } else if (dataType == 4) {
      if (!this.param6 || isNaN(Number(this.param6))) {
        this.sendDataInputIllegal();
        return;
      }
      req.params = this.param6;
    } else if (dataType == 5) {
      if (!this.param7 || isNaN(Number(this.param7))) {
        this.sendDataInputIllegal();
        return;
      }
      req.params = this.param7;
    } else if (dataType == 6) {
      req.params = this.param11;
      if (!!this.param12 && this.param13) {
        req.params = req.params + "," + this.param12 + "," + this.param13;
      }
    } else if (dataType == 7) {
      if (this.param8 == "0") {
        req.params = this.param8;
      } else if (this.param8 == "1") {
        if (!this.param9 || !this.param10) {
          this.sendDataInputIllegal();
          return;
        }
        req.params = this.param8 + "," + this.param9 + "," + this.param10;
      }
    } else if (dataType == 31) {
      req.params = this.firewareID;
    }
    if (!req.params) {
      this.sendDataInputIllegal();
      return;
    }
    this.realSendData(req);
  }

  public getStartCommand(startDate: Date) {
    let nowData = new Date();
    nowData.setHours(0, 0, 0, 0);
  }

  public getTimestampByCommand(dayIndex: number, timeIndex: number): number {
    let nowDate = new Date();
    nowDate.setHours(0, 0, 0, 0);
    let interval = (dayIndex - 1) * 24 * 3600;
    interval = interval - (timeIndex / 4) * 30 * 60;
    return nowDate.getTime() / 1000 - interval;
  }

  private interval;
  /**
   * 发送设备包
   */
  private async sendElectricRecord() {
    // if (this.isSending) {
    //   return;
    // }
    console.log("sendElectricRecord");
    let meter: Meter = this.selectMeters[0];
    if (
      !this.param2 ||
      !this.param3 ||
      new Date(this.param2).getTime() >= new Date(this.param3).getTime()
    ) {
      this.sendDataInputIllegal();
      return;
    }
    let startDate = new Date(this.param2);
    let endDate = new Date(this.param3);
    let electricRecordDays: ElectricRecordDay[] = [];
    for (let i = 0; i < this.selectElectricRecordDays.length; i++) {
      if (
        this.selectElectricRecordDays[i].endTimestamp <
          startDate.getTime() / 1000 ||
        this.selectElectricRecordDays[i].startTimestamp >
          endDate.getTime() / 1000
      ) {
        continue;
      }
      electricRecordDays.push(this.selectElectricRecordDays[i]);
    }
    console.log("sendElectricRecord electricRecordDays:", electricRecordDays);
    if (meter.meterTypeID != 2) {
      this.sendDataInputIllegal();
      return;
    }

    let resNetworkReq: GetRsNetworksReq = <GetRsNetworksReq>{};
    resNetworkReq.page = 1;
    resNetworkReq.pageSize = 1;
    resNetworkReq.subMeterID = meter.id;
    let rsNetworkData: RsNetworkData = await rsNetworks(resNetworkReq);
    if (
      rsNetworkData.code != ResCode.SUCCESS ||
      !rsNetworkData.data ||
      !rsNetworkData.data.data ||
      rsNetworkData.data.data.rsNetworks.length != 1
    ) {
      this.sendDataInputIllegal();
      return;
    }
    let rsNetwork: RsNetwork = rsNetworkData.data.data.rsNetworks[0];
    if (
      rsNetwork.rsNetworkMeters.length != 1 ||
      !rsNetwork.rsNetworkMeters[0].meter ||
      rsNetwork.rsNetworkMeters[0].meter.id <= 0
    ) {
      this.sendDataInputIllegal();
      return;
    }
    console.log("rsNetworks", rsNetworkData.data.data.rsNetworks);
    let req: SendDataReq = this.generateSendDataReq(8);
    let baudIndex = this.selectBaudRates.indexOf(rsNetwork.baudRate) + 1;
    if (baudIndex <= 0) {
      baudIndex = 4;
    }
    req.meterIDs = [];
    req.meterIDs.push(<SimplifyMeter>{
      meterID: rsNetwork.masterMeterId,
      meterTypeID: meter.meterTypeID,
    });
    if (electricRecordDays.length > 0) {
      this.isSending = true;
    }
    if (electricRecordDays.length == 0) {
      console.log("send  all success");
      // clearInterval(this.interval);
      this.isSending = false;
      return;
    }
    let electricRecordDay: ElectricRecordDay = electricRecordDays[0];
    if (!electricRecordDay) {
      this.sendDataInputIllegal();
      return;
    }
    let index = 10 + rsNetwork.rsNetworkMeters[0].index;
    req.params =
      index +
      "04" +
      "," +
      electricRecordDay.command +
      "," +
      electricRecordDay.count +
      "," +
      baudIndex +
      "," +
      10 +
      "," +
      rsNetwork.rsNetworkMeters[0].meter.meterID +
      "," +
      electricRecordDays.length;
    this.realSendData(req);
  }

  private created() {
    this.param1s.push({
      label: this.$t("meter.Instant").toString(),
      value: "1",
    });
    this.param1s.push({
      label: this.$t("meter.RangedEnergyReading").toString(),
      value: "-2",
    });
    this.param1s.push({
      label: this.$t("meter.Get30minRecordLog").toString(),
      value: "2",
    });
    this.param1s.push({
      label: this.$t("meter.RangedEventLog").toString(),
      value: "3",
    });
    this.param1s.push({
      label: this.$t("meter.InstantPowerLineValue").toString(),
      value: "4",
    });
    this.param1s.push({
      label: this.$t("meter.GetVersionInfo").toString(),
      value: "5",
    });
    this.param1s.push({
      label: this.$t("meter.eventLogForRs485").toString(),
      value: "-1",
    });
    this.param1s.push({
      label: this.$t("meter.Get30minRecordLogWithVoltage").toString(),
      value: "6",
    });
    this.param1s.push({
      label: this.$t("meter.GetDiagnosticInformation").toString(),
      value: "7",
    });
    let r = this.$t("electricRecordDays") as any;
    this.electricRecordDays = r;
    let tiemArray: string[] = [
      "00:00 - 05:30",
      "06:00 - 11:30",
      "12:00 - 17:30",
      "18:00 - 23:00",
    ];
    let index = 0;
    let dayStartCommand: number = 1;
    let timeCommandArray: string[] = ["00", "30", "60", "90"];
    let timeCommandNumberArray: number[] = [0, 48, 96, 144];
    for (let i = 0; i < this.electricRecordDays.length; i++) {
      for (let j = 0; j < tiemArray.length; j++) {
        let electricRecordDay: ElectricRecordDay = <ElectricRecordDay>{};
        let s = this.electricRecordDays[i] + " " + tiemArray[j];
        electricRecordDay.label = s;
        electricRecordDay.index = index;
        electricRecordDay.count = 48;
        electricRecordDay.startTimestamp = this.getTimestampByCommand(
          i + 1,
          timeCommandNumberArray[j]
        );
        electricRecordDay.endTimestamp =
          electricRecordDay.startTimestamp + 30 * 60 * 11;
        let dayCommand = (i + 1).toString(16);
        if (dayCommand.length == 1) {
          dayCommand = "0" + dayCommand;
        }
        electricRecordDay.command = dayCommand + timeCommandArray[j];
        this.selectElectricRecordDays.push(electricRecordDay);
        this.recordDayMap.set(s, electricRecordDay);
      }
    }
    this.selectElectricRecordDays.sort(function (a, b) {
      return a.startTimestamp - b.startTimestamp;
    });
    console.log(this.selectElectricRecordDays);
  }

  /**
   * 构造初始的req
   */
  private generateSendDataReq(dataType: number): SendDataReq {
    let req: SendDataReq = <SendDataReq>{};
    let meterIDS: {
      meterID: string;
      meterTypeID: number;
    }[] = [];
    for (let item of this.selectMeters) {
      let meterID: {
        meterID: string;
        meterTypeID: number;
      } = {
        meterID: item.meterID,
        meterTypeID: item.meterTypeID,
      };
      meterIDS.push(meterID);
    }
    req.meterIDs = meterIDS;
    req.dataType = dataType;
    return req;
  }

  public handleSelectFireware(firewareID) {
    for (let f of this.queryFirewares) {
      if (f.id == firewareID) {
        this.firewareMeterTypeID = f.meterTypeID;
      }
    }
  }
  
  /**
   * 真正进行发送数据的网络请求
   * @param req 请求体
   */
  private async realSendData(req: SendDataReq): Promise<boolean> {
    console.log("realSendData", req);
    const res = await sendData(req);
    if (res.code === ResCode.SUCCESS) {
      // this.dialogBatchWrite = false;
      if (req.dataType == -2) {
        this.dialogClearKey = false;
      }
      this.$notify({
        title: this.$t("common.success").toString(),
        message: this.$t("notification.dataPackageSendSuccess").toString(),
        type: "success",
      });
      return true;
    }
    return false;
  }

  /**
   * 请求参数不合法
   */
  public sendDataInputIllegal() {
    this.$notify({
      title: this.$t("common.warning").toString(),
      message: this.$t("notification.inputIllegal").toString(),
      type: "warning",
    });
  }

  private loading = false;

  public onSelectFireware(b) {
    if (b) {
      this.queryFireware("");
    }
  }
  private async queryFireware(query) {
    let req: FirewareCommonReq = <FirewareCommonReq>{};
    let fireware: Fireware = <Fireware>{};
    req.page = 1;
    req.pageSize = 10;
    fireware.name = query;
    req.fireware = fireware;
    this.loading = true;
    const res = await geFirewares(req);
    if (res.code === ResCode.SUCCESS) {
      this.queryFirewares = res.data.firewares.list;
      this.loading = false;
    }
  }
}
